import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getCancelledClientsCount = async (): Promise<number> => {
  const fetchURL = getM8PartnerURL('getCancelledClientsCount');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  const value = await response.json();

  return value;
};
